import Close from '@mui/icons-material/Close';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import NavigateNext from '@mui/icons-material/NavigateNext';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { SxProps, Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import JobStatusChip from '~components/Job/JobStatusChip';
import { Status as LoadStatus } from '~components/Job/LoadStatus';
import { Job } from '~hooks/useJob/models';
import { Load } from '~hooks/useLoad/models';

import { SmallIconButton } from './styled';

interface DrawerHeaderProps {
  job: Job;
  load?: Load;
  loadNumber?: number;
  nextUnavailableReason?: string;
  onClose: () => void;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
  previousUnavailableReason?: string;
  sx?: SxProps<Theme>;
}

export default function DrawerHeader({
  job,
  load,
  loadNumber,
  nextUnavailableReason,
  onClose,
  onNextClick,
  onPreviousClick,
  previousUnavailableReason,
  sx,
}: DrawerHeaderProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          alignItems: 'center',
          borderBottom: `solid 1px ${theme.palette.divider}`,
          display: 'flex',
          justifyContent: 'space-between',
          px: 2,
          py: 1,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title={!onPreviousClick ? (previousUnavailableReason ?? '') : ''}>
            <span>
              <SmallIconButton
                disabled={!onPreviousClick}
                onClick={onPreviousClick}
                sx={{
                  ...(onPreviousClick
                    ? {}
                    : { pointerEvents: 'auto !important', cursor: 'not-allowed' }),
                }}
              >
                <NavigateBefore />
              </SmallIconButton>
            </span>
          </Tooltip>

          <Tooltip title={!onNextClick ? (nextUnavailableReason ?? '') : ''}>
            <span>
              <SmallIconButton
                disabled={!onNextClick}
                onClick={onNextClick}
                sx={{
                  ...(onNextClick
                    ? {}
                    : { pointerEvents: 'auto !important', cursor: 'not-allowed' }),
                }}
              >
                <NavigateNext />
              </SmallIconButton>
            </span>
          </Tooltip>
        </Box>

        <Typography
          sx={(theme) => ({
            color: theme.brandV2.colors.treadBlack,
            fontSize: '16px',
            fontWeight: 600,
          })}
        >
          <Typography
            component="span"
            sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}
          >
            {load && loadNumber !== undefined
              ? `${t('form_fields.load')} ${loadNumber}`
              : job.jobId}
          </Typography>
        </Typography>

        {load && loadNumber !== undefined ? (
          <LoadStatus status={load.state} />
        ) : (
          <JobStatusChip hideDropdownArrow jobState={job.status} />
        )}
      </Box>

      <IconButton color="inherit" size="small" onClick={onClose}>
        <Close sx={{ width: 16, height: 16 }} />
      </IconButton>
    </Box>
  );
}
